import * as React from "react";
import { useTranslation } from "react-i18next";
import { PlayerFragmentFragment } from "../../../graphql/PlayerFragment.generated";
import { VipExpiryContentFragmentFragment } from "../../../graphql/ActivityFragment.generated";
import { useRelativeTimeFormatter } from "../../../hooks/useRelativeTimeFormatter";
import { usePackOffer } from "./usePackOffer";
import { OpenOfferButton } from "./OpenOfferButton";

export const VipExpiryActivity = ({
  content,
  setRead,
}: {
  actor: PlayerFragmentFragment | null;
  content: VipExpiryContentFragmentFragment;
  openProfile: () => void;
  setRead: () => void;
}) => {
  const { t } = useTranslation();
  const relativeTimeFormatter = useRelativeTimeFormatter();
  const { open, fetching } = usePackOffer(content.offerId, setRead);
  const vipUntil = new Date(content.vipUntil);

  return (
    <div>
      <strong className="block">
        {vipUntil > new Date()
          ? t("vip_expiry.title", {
              time: relativeTimeFormatter.format(vipUntil),
            })
          : t("vip_expiry.title_expired")}
      </strong>
      <div className="text-sm">{content.message}</div>
      <OpenOfferButton open={open} fetching={fetching} />
    </div>
  );
};
